// extracted by mini-css-extract-plugin
module.exports = {"description":"Tags_description__3jjRw","tagsContainer":"Tags_tagsContainer__VhbRF"};